<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">我的页面配置</div>

      <div class="search-wrapper">
         <el-form :inline="true" v-model="paramData">
            <el-form-item label="类型">
               <el-select placeholder="请选择类型" v-model="paramData.type">
                  <el-option label="全部" :value="-1"></el-option>
                  <el-option label="运动服务" :value="1"></el-option>
                  <el-option label="常用功能" :value="2"></el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="状态">
               <el-select placeholder="请选择状态" v-model="paramData.status">
                  <el-option label="全部" :value="-1"></el-option>
                  <el-option label="已发布" :value="0"></el-option>
                  <el-option label="已撤销" :value="1"></el-option>
               </el-select>
            </el-form-item>
         </el-form>
         <el-button type="primary" @click="queryList">搜索</el-button>
         <el-button @click="clickReset">重置</el-button>
      </div>

      <div class="action-wrapper">
         <el-button type="primary" @click="clickAddition">新增</el-button>
      </div>

      <div class="content-wrapper">
         <el-table :data="listData">
            <el-table-column align="center" label="排序" type="index" width="80" prop="order">
            </el-table-column>
            <el-table-column align="center" label="模块ID" prop="moduleId"></el-table-column>
            <el-table-column align="center" label="图标" min-width="160">
               <template scope="{ row }">
                  <div class="flex-row-center margin-bottom-10">
                     <img class="table-img" :src="row.iconUrl" alt="">
                  </div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="名称" prop="name"></el-table-column>
            <el-table-column align="center" label="链接" prop="jumpUrl"></el-table-column>
            <el-table-column align="center" label="学校" min-width="180">
               <template scope="{ row }">
                  <div v-if="row.scopeType === 1">
                     共计屏蔽{{ row.usedSchoolCount || 0 }}所学校
                  </div>
                  <div v-else-if="row.scopeType === 2">
                     共计应用{{ row.usedSchoolCount || 0 }}所学校
                  </div>
                  <div v-else>-</div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="状态">
               <template scope="{ row }">
                  <div v-if="row.status === 0">已发布</div>
                  <div v-if="row.status === 1">已撤销</div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="最近操作时间">
               <template scope="{ row }">
                  <div>{{ new Date(row.updateTime).format("yyyy-MM-dd hh:mm:ss") }}</div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="180">
               <template scope="{ row }">
                  <el-button v-if="row.status === 1" type="text" @click="clickPublish(row)">发布</el-button>
                  <el-button v-if="row.status === 1" type="text" @click="clickEditing(row)">编辑</el-button>
                  <el-button v-if="row.status === 0" type="text" style="color: red" @click="clickRevoke(row)">撤销
                  </el-button>
                  <el-button type="text" style="color: red" @click="clickDelete(row)">删除</el-button>
               </template>
            </el-table-column>
         </el-table>
         <div class="pagination-wrapper">
            <el-pagination v-show="total > 0" layout="prev, pager, next, jumper" :current-page="paramData.pageNum"
               :page-size='paramData.pageSize' :total="total" @current-change="changeCurrentPage">
            </el-pagination>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   data() {
      return {
         loading: false,
         paramData: {
            type: -1, // 类型 1-运动服务 2-常用功能
            status: -1, // 状态 0-已发布 1-已撤销
            pageNum: 1,
            pageSize: 10,
         },
         total: 0,
         listData: [],
      }
   },

   mounted() {
      this.queryList();
   },

   methods: {
      // 查询列表
      queryList() {
         this.loading = true;
         this.$http({
            url: this.$util.domain + '/app-modules/list',
            method: 'POST',
            body: JSON.stringify(this.paramData)
         }).then((res) => {
            if (res.body.error === 10000 && res.body.data) {
               this.total = res.body.data.count || 0;
               this.listData = res.body.data.models || [];
            } else {
               this.total = 0;
               this.listData = [];
            }
         }).catch((err) => {
            this.total = 0;
            this.listData = [];
         }).finally(() => {
            this.loading = false;
         })
      },
      // 更新状态（发布或撤销）
      updateStatus(params) {
         let message = '确定要发布吗？发布后该篇会变成“已发布”状态，且用户端将会看到该篇内容';
         let title = '发布';
         if (params.status === 1) {
            message = '确定要撤销发布吗？撤销发布后该篇会变成“已撤销”状态，且用户端将无法看到该篇内容';
            title = '撤销';
         }
         this.$confirm(message, title, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.loading = true;
            this.$http({
               url: this.$util.domain + "/app-modules/publish",
               method: "POST",
               body: JSON.stringify({ ...params })
            }).then((res) => {
               if (res.body.error === 10000) {
                  this.$message.success('操作成功');
                  this.queryList();
               } else {
                  this.$util.errorMsg(res.body.message || "请联系管理员");
               }
            }).catch((err) => {
               this.$util.errorMsg(err.message);
            }).finally(() => {
               this.loading = false;
            });
         }).catch(() => { });
      },
      // 发送删除
      sendDelete(params) {
         this.$confirm('确定要删除吗？', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.loading = true;
            this.$http({
               url: this.$util.domain + "/app-modules/delete",
               method: "POST",
               body: JSON.stringify({ ...params })
            }).then((res) => {
               if (res.body.error === 10000) {
                  this.$message.success('删除成功');
                  this.queryList();
               } else {
                  this.$util.errorMsg(res.body.message || "请联系管理员");
               }
            }).catch((err) => {
               this.$util.errorMsg(err.message);
            }).finally(() => {
               this.loading = false;
            });
         }).catch(() => { });
      },
      // 点击重置
      clickReset() {
         this.paramData = {
            type: -1,
            status: -1,
            pageNum: 1,
            pageSize: 10,
         };
         this.queryList();
      },
      // 点击新增按钮
      clickAddition() {
         this.$router.push({
            path: '/yunying/advertising/mine/detail',
            query: { actionType: 'add' }
         })
      },
      // 点击发布
      clickPublish(row) {
         const params = {
            id: row.id,
            status: 0,
         };
         this.updateStatus(params);
      },
      // 点击编辑
      clickEditing(row) {
         this.$router.push({
            path: '/yunying/advertising/mine/detail',
            query: { actionType: 'edit', id: row.id }
         })
      },
      // 点击撤销
      clickRevoke(row) {
         const params = {
            id: row.id,
            status: 1,
         };
         this.updateStatus(params);
      },
      // 点击删除
      clickDelete(row) {
         this.sendDelete(row);
      },
      // 切换当前页码
      changeCurrentPage(val) {
         this.paramData.pageNum = val;
         this.queryList();
      },
   }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// MinePage.vue?2c1b07cd